import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "@/App.css";
import Login from "./pages/Login";
import VerifyOtp from "./pages/VerifyOtp";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import { fetchMe } from "./lib/api";

function ProtectedRoute({ children }) {
  const [state, setState] = useState({ checking: true, authed: false });

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setState({ checking: false, authed: false });
      return;
    }
    (async () => {
      try {
        await fetchMe();
        setState({ checking: false, authed: true });
      } catch {
        setState({ checking: false, authed: false });
      }
    })();
  }, []);

  if (state.checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="spinner" />
      </div>
    );
  }
  if (!state.authed) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously (URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/verify-otp" element={<VerifyOtp />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
